import React from "react";
import { Control } from 'react-redux-form';

interface Props {
  model: string;
  placeholder?: string;
  disabled?: boolean;
}

/*  Wrapper for the Control.textarea RRF component.
    Parses any RRF State value that is null to an empty string. This is required because values from the DB
    are quite often null and Control.textarea cannot take a null value. */
export class TextareaInput extends React.Component<Props> {
  private parseVal = (val: string): string => val || '';

  public render() {
    return (
      <Control.textarea {...this.props} parser={this.parseVal} />
    );
  }
}
